import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MenubarTriggerDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    getHitArea
} from "../../../../helpers/theme/control";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    surface: {
        justifyContent: "center",
        borderStyle: "solid",
        alignItems: "center"
    },
    anchor: {
        justifyContent: "center"
    },
    title: {
        textAlign: "center"
    }
});

export const useStyles = ({
    isFocusVisible,
    currentColors,
    shapeConfigs,
    touchTargets,
    currentSize,
    pointerType,
    isDisabled,
    radiuses,
    borders,
    barPad,
    colors
}: MenubarTriggerDynamicStyleType) => {
    const hitArea = getHitArea({
        visualSize: currentSize.minHeight,
        touchTargets,
        pointerType
    });

    const styles = {
        surface: {
            paddingHorizontal: currentSize.paddingHorizontal,
            backgroundColor: currentColors.containerColor,
            borderColor: currentColors.borderColor,
            minHeight: currentSize.minHeight,
            ...getCornerStyle({
                radius: radiuses.actions,
                shapeConfigs
            }),
            borderWidth: borders.line
        } as Mutable<ViewStyle>,
        container: {
            minHeight: hitArea.minHeight,
            minWidth: hitArea.minWidth
        } as Mutable<ViewStyle>,
        anchor: {
            paddingBottom: barPad,
            marginBottom: -barPad
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.surface, getFocusRingStyle({
        isFocusVisible,
        borders,
        colors
    }));

    if(isDisabled) {
        Object.assign(styles.container, webStyle({
            cursor: "not-allowed"
        }));
    }

    return styles;
};
export default stylesheet;
